<div id="popup">
	<h1 class="titulo">FINALIZACIÓN CONVENIO SANCOR</h1>

	<p>Tal como ha sido informado vía email, el convenio establecido con la prestadora Sancor Salud finalizó el 31/01. Por cualquier consulta sobre cobertura actual de dicho grupo de beneficiarios, contactate con nosotros desde la web con usuario registrado a través de “Otras gestiones y solicitudes” o telefónicamente al <a href="tel:08103333273">0810-3333-273</a>.</p>


</div>